export const AccessBlacklistType = {
    User: 1,
    Ip: 2,
} as const;

export type AccessBlacklistTypeValue = typeof AccessBlacklistType[keyof typeof AccessBlacklistType];

export interface AccessBlacklistRow {
    id: number;
    type: number;
    value: string;
    reason: string;
    createdBy: string;
    created: string;
    updated: string;
    expiresAt?: string | null;
    lastAttemptAt?: string | null;
    isDeleted: boolean;
}

export function accessBlacklistTypeLabel(type: number): string {
    if (type === AccessBlacklistType.User) {
        return 'Пользователь';
    }
    if (type === AccessBlacklistType.Ip) {
        return 'IP';
    }
    return String(type);
}
